import { KumaViewDto } from "src/services/Client";

export const myTheme = {
  baseTheme: "ag-default",
  palette: {
    fills: ["#810011", "#a6140f", "#981417"],
    strokes: ["black"],
  },
};
const series = [
  {
    type: "pie",
    angleKey: "value",
    calloutLabelKey: "label",
    sectorLabelKey: "value",
    sectorLabel: {
      color: "white",
      fontWeight: "bold",
    },
    highlightStyle: {
      item: {
        fill: "red",
        stroke: "maroon",
        strokeWidth: 2,
      },
    },
  },
];
const barSeries = [
  {
    type: "bar",
    direction: "horizontal",
    xKey: "label",
    yKey: "status",
    formatter: (params: any) => {
      return {
        fill: params.highlighted ? "red" : params.datum.fill,
        fillOpacity:0.2,
      };
    },
    label: {
      placement: "outside",
      rotation: 90,
      formatter: ({ value }: any) => `(${value.toFixed(0)})`,
    },
    highlightStyle: {
      item: {
        fill: "red",
        stroke: "maroon",
        strokeWidth: 2,
      },
    },
  },
];
export const getNoOfReqVsActualityConfig = (data: any, t: any) => {
  return {
    theme: myTheme,
    padding: {
      top: 0,
      right: 0,
      bottom: 40,
      left: 0,
    },
    data: [
      { label: t("KUMA_THIS_MONTH"), value: data.month },
      { label: t("KUMA_THIS_YEAR"), value: data.year },
      { label: t("KUMA_ALL_REQUIREMENTS"), value: data.requirements },
    ],
    series,
    legend: {
      position: "bottom",
    },
    background: {
      visible: false,
    },
  };
};
export const getMarketVsRequirementConfig = (data: any) => {
  return {
    theme: myTheme,
    data,
    series,
    padding: {
      top: 20,
      right: 20,
      bottom: 40,
      left: 20,
    },
    legend: {
      position: "bottom",
    },
    background: {
      visible: false,
    },
  };
};
export const getRequirementByStatusConfig = (data: any, t: any) => {
  return {
    theme: myTheme,
    title: {
      text: t("KUMA_REQ_PER_STATUS"),
    },
    data,
    padding: {
      top: 20,
      right: 40,
      bottom: 20,
      left: 20,
    },
    series: barSeries,
    axes: [
      {
        type: "category",
        position: "left",
        label: {},
      },
      {
        type: "number",
        position: "bottom",
        label: {
          formatter: ({ value }: any) => "",
        },
      },
    ],
    legend: {
      enabled: false,
    },
    background: {
      visible: false,
    },
  };
};
export const getUniqueDataWithSeries = (collection: any, key: string) => {
  const uniqueCollection = collection.filter(
    (obj: any, index: number, self: any) =>
      index === self.findIndex((o: any) => o[key] === obj[key])
  );
  return uniqueCollection;
};
export const setUniqueData = (
  uniqueCollection: any,
  seriesData: any,
  name: string,
  idCol: string
) => {
  uniqueCollection.map((cnr: any) => {
    seriesData.push({ label: cnr[name], value: 0, id: cnr[idCol] });
  });
};
export const getDistinctData = (activeRequirements: any, key: string) => {
  const assginedEntity = activeRequirements.map((req: KumaViewDto) => req[key]);
  const allData: any = [];
  assginedEntity.map((item: any) => {
    item.map((subItem: any) => {
      allData.push(subItem);
    });
  });
  return allData;
};



// WEBPACK FOOTER //
// ./src/components/kuma/ChartConfig.ts